import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'timeAgo',
    pure: true,
    standalone: false
})
export class TimeAgoPipe implements PipeTransform {

    transform(value: any, format: 'full' | 'compact' = 'full'): any {
        if (value) {
            const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
            if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
                return 'just now';
            const intervals = {
                'year': 31536000,
                'month': 2592000,
                'week': 604800,
                'day': 86400,
                'hour': 3600,
                'minute': 60,
                'second': 1
            };
            let counter;
            for (const i in intervals) {
                counter = Math.floor(seconds / intervals[i]);
                if (counter > 0) {
                    const unit = counter === 1 ? i : i + 's';
                    const suffix = format === 'compact' ? '' : ' ago';
                    return counter + ' ' + unit + suffix;
                }
            }
        }
        return value;
    }

}
